<ng-container *ngIf="user">
  <button *ngIf="user | hasRole: userRole.LobbyAdministrator" routerLink="{{appRoute.administrator}}"
    queryParamsHandling="preserve">Administrator<br><br>Configurazione<br>Ruoli</button>

  <button *ngIf="user | hasRole: userRole.LobbyAuthorized" routerLink="{{appRoute.agent}}"
    queryParamsHandling="preserve">Agent<br><br>Contatti<br>Lead</button>

  <button *ngIf="user | hasRole: userRole.LobbyAuthorized" routerLink="{{appRoute.agentpreferences}}"
    queryParamsHandling="preserve">Settings<br><br>&lbrace;mio nome&rbrace;<br>Preferenze</button>

  <button *ngIf="user | hasRole: userRole.LobbyAgentSupervisor" routerLink="{{appRoute.agentsupervisor}}"
    queryParamsHandling="preserve">Agent
    supervisor<br><br>Contatti<br>Lead struttura</button>

  <button *ngIf="user| hasRole: userRole.LobbyAgentManager" routerLink="{{appRoute.agentmanager}}"
    queryParamsHandling="preserve">Agent
    manager<br><br>Gestione<br>Struttura</button>

  <button *ngIf="user| hasRole: userRole.LobbyLeadManager" routerLink="{{appRoute.leadmanager}}"
    queryParamsHandling="preserve">Lead
    manager<br><br>Gestione<br>Struttura lead</button>

  <button *ngIf="user| hasRole: userRole.LobbyAdministrator" routerLink="{{appRoute.leadinjector}}"
    queryParamsHandling="preserve">Lead
    injector<br><br>Configurazione<br>Lead injectors</button>
</ng-container>
